import { cn } from "utils/cn";

export const HelpText: React.FunctionComponent<
  React.ComponentPropsWithoutRef<"div">
> = (props) => (
  <div
    {...props}
    className={cn(
      "text-sm text-zi-secondaryText [&_a:visited]:text-inherit [&_a]:underline",
      props.className
    )}
  />
);
